import {useAnnotationModeStore} from './AnnotationModeStore';
import {useIsAnnotationModeAvailable} from './useIsAnnotationModeAvailable';
import {useIsSessionOnlyAnnotationModeAvailable} from './useIsSessionOnlyAnnotationModeAvailable';

/** The store flag alone is not enough: it stays on after a surface stops qualifying. */
export function useIsAnnotationModeActive(isSessionOnlyMode = false): boolean {
  const isAnnotationModeOn = useAnnotationModeStore((state) => state.isAnnotationModeOn);
  const isAssignmentAvailable = useIsAnnotationModeAvailable();
  const isSessionOnlyAvailable = useIsSessionOnlyAnnotationModeAvailable();

  return isAnnotationModeOn && (isSessionOnlyMode ? isSessionOnlyAvailable : isAssignmentAvailable);
}
